import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-criminal-emp',
  templateUrl: './view-criminal-emp.component.html',
  styleUrls: ['./view-criminal-emp.component.css']
})
export class ViewCriminalEmpComponent implements OnInit {
  title="Details of Employees with Criminal proceedings";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/staff-criminal-proceedings/view-criminal-emp/view-criminal-emp.component.ts